<div class="widgets">
  <div class="title" (click)="voirPlus()">
    <ion-item class="title_left" lines="none">
      <i class="fa fa-briefcase" aria-hidden="true"></i>
      {{ 'HOME.DAILY_OTS.TITLE' | translate }}
    </ion-item>
    <a data-test="view-ots-link-data-test" class="title_right">
      {{
        isCurrentUserDiffu
          ? ('HOME.DAILY_OTS.SEE_MORE_DIFFU' | translate)
          : ('HOME.DAILY_OTS.SEE_MORE_NON_DIFFU' | translate)
      }}
    </a>
  </div>
  <div class="content" [ngClass]="{ center: (!loading() && !otCardItems()) || otCardItems()?.length === 0 }">
    @if (loading()) {
      <div class="loading-content center">
        <ion-icon name="sync" class="infinite-rotate"></ion-icon>
        <span>{{ 'GLOBAL.LOADING' | translate }}</span>
      </div>
    } @else {
      @if (otCardItems().length > 0) {
        <div class="scrollable-swipe">
          @for (otCardItem of otCardItems(); track otCardItem) {
            <div class="slide">
              <daily-ot-card [otCardItem]="otCardItem"></daily-ot-card>
            </div>
          }
        </div>
      } @else {
        @if (networkStatus === NetworkStatusEnum.OFFLINE) {
          <div class="networkStatus">
            <span [innerHTML]="'HOME.DAILY_OTS.PROBLEM_OCCURED' | translate"></span>
          </div>
        } @else {
          <div class="msg">
            <span>{{ 'HOME.DAILY_OTS.NO_OTS' | translate }}</span>
          </div>
        }
      }
    }
  </div>
</div>
